import { Core } from "@faire/design-tokens";
import { IDepartment } from "@faire/retailer-shared/greenhouse/greenhouseApi";
import { Chevron } from "@faire/web/slate/icons/foundation/Chevron";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";

export const JobOpeningJobsWithTier: React.FC<{ department: IDepartment }> = ({
  department,
}) => {
  const childDepartments = department.childDepartments;
  return childDepartments.length > 0 ? (
    <>
      {childDepartments.map((department: IDepartment) => (
        <Column gap="1x" key={department.name}>
          <Typography variant="subheadingSansMedium">
            {department.name}
          </Typography>
          <div>
            <JobOpeningsJobs department={department} />
          </div>
        </Column>
      ))}
    </>
  ) : (
    <JobOpeningsJobs department={department} />
  );
};

const JobOpeningsJobs: React.FC<{ department: IDepartment }> = ({
  department,
}) => {
  return department.jobs.map((job, i) => (
    <JobLink
      $gray={!!((i + 1) % 2 !== 0)}
      href={job.absolute_url}
      key={job.absolute_url}
      target="_blank"
    >
      <ResponsiveLine>
        <JobTitle>{job.title}</JobTitle>
        <Typography color={Core.text.subdued}>{job.location.name}</Typography>
      </ResponsiveLine>
      <Spacer width="4x" />
      <StyledChevron direction="right" />
    </JobLink>
  ));
};

const ResponsiveLine = styled(Column)`
  flex: 1;
`;

const StyledChevron = styled(Chevron)`
  transition: transform 400ms;
`;

const JobLink = styled(Anchor)<{ $gray: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${({ $gray }) =>
    $gray ? Core.surface.muted : Core.surface.inverse};
  padding: ${getSpacing("2x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("2x", "3x")};
  }

  &:hover {
    ${StyledChevron} {
      transform: translateX(4px);
    }
  }
`;

const JobTitle = styled(Typography).attrs({ variant: "paragraphSansMedium" })``;
